import { Button } from '@playbookux/playbook-web-core';
import styled from 'styled-components';

export const ClickConfirmationContainer = styled.div`
  position: absolute;
  top: ${({ y, imageSizeY }) => ((y > 10 ? y + 10 : y) / imageSizeY) * 100}%;
  left: ${({ x, imageSizeX }) => ((x > 10 ? x + 10 : x) / imageSizeX) * 100}%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #F8F8F8F8;
  color: ${({ theme }) => theme.text};
  padding: 1vw;
  border-radius: 5px;

  cursor: pointer;
  gap: 1vh;
  // allow overflow
  white-space: nowrap;
`;

export const Ball = styled.div`
 top: ${({ y, imageSizeY }) => `${((y > 5 ? y - 5 : y) / imageSizeY) * 100}%`};
 left: ${({ x, imageSizeX }) => `${((x > 5 ? x - 5 : x) / imageSizeX) * 100}%`};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  content: '';
  position: absolute;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: blue;
`;

export const ClickConfirmationButton = styled(Button)`
  width: 100%;
`;

export const ClickRedoButton = styled(Button.Inverted)`
  width: 100%;
`;
